import '../../sass/vendors/_aos.scss'

import AOS from 'aos'

export default AOS
